import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-core-info-messages',
  templateUrl: './core-info-messages.component.html',
  styleUrl: './core-info-messages.component.scss'
})
export class CoreInfoMessagesComponent {
  @Input() type: 'success' | 'error' | 'info' | 'warning'= 'info'; // Varsayılan değer 'info'
  @Input() message: string = '';
  @Input() closable: boolean = false; // Kapatma özelliği
  isVisible: boolean = true; // Mesajın görünür olup olmadığını kontrol etmek için

  close() {
    this.isVisible = false; // Mesajı gizle
  }
  get iconColor() {
    switch (this.type) {
      case 'success':
        return 'green'; // Başarı durumu için yeşil
      case 'error':
        return 'red'; // Hata durumu için kırmızı
      case 'warning':
        return 'yellow'
      case 'info':
      default:
        return '#007ad9'; // Bilgi durumu için mavi
    }
  }
  get backgroundColor() {
    switch (this.type) {
      case 'success':
        return '#d4edda'; // Başarı durumu için açık yeşil arka plan
      case 'error':
        return '#f8d7da'; // Hata durumu için açık kırmızı arka plan
      case 'warning':
        return 'rgba(255, 173, 37, 0.9)'; // uyarı durumu için açık kırmızı arka plan
      case 'info':
      default:
        return '#e7f3fe'; // Bilgi durumu için açık mavi arka plan
    }
  }

  get borderStyle() {
    switch (this.type) {
      case 'success':
        return '1px solid #c3e6cb'; // Başarı durumu için yeşil kenar
      case 'error':
        return '1px solid #f5c6cb'; // Hata durumu için kırmızı kenar
      case 'info':
      default:
        return '1px solid #b3d8ff'; // Bilgi durumu için mavi kenar
    }
  }
}
